import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { SkillsApi } from '@/lib/api/skills';
import type { Skill } from '@/lib/api/types/skills';
import { capacityQueryKeys } from '@/lib/query-keys/capacity';

export const getSkillsQueryOptions = () => {
  return {
    queryKey: capacityQueryKeys.skills.all(),
    queryFn: async () => {
      return await SkillsApi.getSkills();
    },
  };
};

export const useSkillsQuery = (options: Partial<UseQueryOptions<Skill[]>> = {}) => {
  return useQuery({ ...getSkillsQueryOptions(), ...options });
};
